import { render, staticRenderFns } from "./addcountUsdt.vue?vue&type=template&id=2486192c&scoped=true&"
import script from "./addcountUsdt.vue?vue&type=script&lang=js&"
export * from "./addcountUsdt.vue?vue&type=script&lang=js&"
import style0 from "./addcountUsdt.vue?vue&type=style&index=0&id=2486192c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2486192c",
  null
  
)

export default component.exports